import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { setupFaro } from '@/common/services/faro'

import { App } from './App'

// Faro inicializado antes do render para capturar traces desde o primeiro fetch/XHR
setupFaro()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
